import React, { useState } from "react";
import "../styles/UgcNetRegistration.css";

const UgcNetRegistration = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const [showQR, setShowQR] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, mobile } = formData;

    if (!name || !email || !mobile) {
      alert("Please fill all fields.");
      return;
    }

    try {
      const response = await fetch("https://cveysolutions.in/api/ugcnet/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, mobile }),
      });

      if (!response.ok) {
        throw new Error("Failed to register");
      }

      setShowQR(true);
      setFormData({ name: "", email: "", mobile: "" });
    } catch (error) {
      console.error("Registration failed:", error);
      alert("Registration failed. Please try again.");
    }
  };

  return (
    <div className="ugcnet-wrapper" style={{ minHeight: "100vh", background: "linear-gradient(135deg, #0f2027, #2c7744)", color: "white", padding: "60px 20px", fontFamily: "'Poppins', sans-serif" }}>
      <a href="/documents/ugcnet-brochure.pdf" target="_blank" rel="noopener noreferrer" className="poster-button">📄 Brochure</a>

      <div className="ugcnet-heading">
        <h2 style={{ color: "white" }}>UGC NET Classes Registration - CVEY Institutions</h2>
        <p className="ugcnet-subtext">
          🗓️ <strong>Demo Classes:</strong> 27th to 28th June (6am to 7:30 am)<br />
          📚 <strong>Course Duration:</strong> 1st July – 30th November<br />
          💰 <strong>Fee:</strong> ₹15000 + 18% GST
        </p>
      </div>

      <div className="ugcnet-content">
        <div className="ugcnet-left animate-left">
          <h3>Why Join Our UGC NET Program?</h3>
          <ul>
            <li>✔️ Expert Faculty with NET/JRF Qualification</li>
            <li>✔️ Updated Materials & Practice Tests</li>
            <li>✔️ Doubt Sessions & Daily Assignments</li>
            <li>✔️ Affordable Fee Structure (₹3000 only)</li>
            <li>✔️ 100% Online Interactive Classes</li>
          </ul>
          <div className="important-note">
            <p>⚠️ <strong>Note:</strong> Please send the payment receipt to <a href="mailto:support@cveysolutions.in">support@cveysolutions.in</a>.</p>
            <p className="blinking-text">❗<strong>Without the receipt, your payment will not be approved.</strong></p>
            <p>For any queries, contact us at <a href="mailto:support@cveysolutions.in">support@cveysolutions.in</a>.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="ugcnet-form animate-right">
          <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Email ID" value={formData.email} onChange={handleChange} required />
          <input type="tel" name="mobile" placeholder="Mobile Number" value={formData.mobile} onChange={handleChange} required />
          <button type="submit">Register</button>
        </form>
      </div>

      {/* ✅ QR Code Modal */}
      {showQR && (
        <div className="qr-modal">
          <div className="qr-content">
            <h3>Scan this QR to Pay</h3>
            <img src="/images/ugcnet-qr.jpg" alt="Scan to Pay" className="qr-image" />
            <button onClick={() => setShowQR(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UgcNetRegistration;
